import { Link } from "react-router-dom";
import { UserMenu } from "@/components/UserMenu";
import { LangSwitch } from "@/components/LangSwitch";

import { tr } from "@/lib/i18n";
export const AppHeader = ({ children }) => (
  <header className="h-16 shrink-0 bg-white border-b border-slate-200 flex items-center px-4 sm:px-6 gap-4 z-[500] relative">
    <Link to="/" data-testid="header-home-link" className="flex items-center gap-2.5 shrink-0">
      <img src="/synvora-logo-dark.svg" alt="Synvora" className="h-8 w-auto hidden sm:block" data-testid="header-logo" />
      <img src="/synvora-mark.png" alt="Synvora" className="h-8 w-8 sm:hidden" />
      <span className="font-tech text-[11px] uppercase tracking-[0.25em] text-[#0F52BA] pt-1.5 hidden sm:inline">{tr("Design")}</span>
    </Link>
    <div className="flex-1 flex items-center justify-end gap-3 min-w-0">{children}<LangSwitch loggedIn /><UserMenu /></div>
  </header>
);
